import { render } from "./chose-service.vue?vue&type=template&id=cbb56dba&scoped=true"
import script from "./chose-service.vue?vue&type=script&lang=js"
export * from "./chose-service.vue?vue&type=script&lang=js"

import "./chose-service.vue?vue&type=style&index=0&id=cbb56dba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbb56dba"]])

export default __exports__